import { render, staticRenderFns } from "./LmSuperPowerSelectV2.vue?vue&type=template&id=512dc7f4"
import script from "./LmSuperPowerSelectV2.vue?vue&type=script&lang=js"
export * from "./LmSuperPowerSelectV2.vue?vue&type=script&lang=js"
import style0 from "./LmSuperPowerSelectV2.vue?vue&type=style&index=0&id=512dc7f4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports